/**
 * * Модель запроса создания группы
 */
export default class GroupCreateRequest  {
	/**
	 * * Ид проекта
	 */
	NamespaceId!: string;
	/**
	 * * Название
	 */
	Name!: string;
	/**
	 * * Ид родительской группы
	 */
	ParentId?: number;
	constructor(obj?: Partial<GroupCreateRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
